import { Component } from '@angular/core';
import { HomeService } from '../home.service';

@Component({
  selector: 'app-dealer-portal',
  templateUrl: './dealer-portal.component.html',
  styleUrls: ['./dealer-portal.component.css']
})
export class DealerPortalComponent {

  constructor(private homeService: HomeService){}

  /**
   * files: [File Name for UI, file name saved in bucket]
   */
  documentPath = {
    //Chargers
    'TroubleShooting-Chargers': { 
      files: [
        ['710-00032.1 Quantum Charger Quick Troubleshooting Guide', '1-710-00032.1-Quantum-Charger-Quick-Troubleshooting-Guide.pdf'],
        ['710-00029.1 Quantum Charger Stack Light Color Code', '2-710-00029.1-Quantum-Charger-Stack-Light-Color-Code.pdf'],
        ['710-00023.2 AC Backplane Daughter Card LED Color Code and Debugging', '3-710-00023.2-AC-Backplane-Daughter-Card-LED-Color-Code-and-Debugging.pdf'],
        ['710-00021.1 Quantum Charger Error Code', '4-710-00021.1-Quantum-Charger-Error-Code-.pdf'],
        ['710-00009.3 Charger LED Light Guide', '5-710-00009.3-Charger-LED-Light-Guide.pdf'],
        ['710-00008.5 Quantum Charger Faults and Alerts', '6-710-00008.5-Quantum-Charger-Faults-and-Alerts.pdf']]
    },
    'Programming&Replacement-Chargers':{
      files: [
        ['710-00036.5 Lithium Ion CAN Communication Connection and Settings', '1-710-00036.5-Lithium-Ion-CAN-Communication-Connection-and-Settings.pdf'],
        ['710-00031.2 Quantum Charger AC and DC Backplane Replacement Procedure', '2-710-00031.2-Quantum-Charger-AC-and-DC-Backplane-Replacement-Procedure.pdf'], 
        ['710-00027.1 Quantum Charger LCD Screen Calibration Procedure', '3-710-00027.1-Quantum-Charger-LCD-Screen-Calibration-Procedure.pdf'],
        ['710-00026.1 Field MCB Voltage Calibration', '4-710-00026.1-Field-MCB-Voltage-Calibration.pdf'], 
        ['710-00013.1 Time Zone Change Update', '5-710-00013.1-Time-Zone-Change-Update.pdf'],
        ['710-00011.1 MCB Replacement Procedure', '6-710-00011.1-MCB-Replacement-Procedure.pdf']]
    },
    'Technical-Specifications-Chargers':{
      files: [
        ['710-00035.1 Battery Temperature Management and Compensation', '1-710-00035.1-Battery-Temperature-Management-and-Compensation.pdf'],
        ['710-00028.2 Quantum Charger Improvements', '2-710-00028.2-Quantum-Charger-Improvements.pdf'], 
        ['710-00020.4 Quantum Charger and Power Modules Serial Number Breakdown', '3-710-00020.4-Quantum-Charger-and-Power-Modules-Serial-Number-Breakdown.pdf'],
        ['710-00018.3 Quantum Charger Dimensions and Mounting Patterns', '4-710-00018.3-Quantum-Charger-Dimensions-and-Mounting-Patterns.pdf'], 
        ['710-00017.4 Quantum Charger Technical Specifications-Full', '5-710-00017.4-Quantum-Charger-Technical-Specifications-Full.pdf'],
        ['710-00016.5 Quantum Charger Technical Specifications-short', '6-710-00016.5-Quantum-Charger-Technical-Specifications-short.pdf']]
    },
     'Manuals-Chargers':{
      files: [
        ['710-00040.3 ACT Preventive Maintenance Guide', '1-710-00040.3-ACT-Preventive-Maintenance-Guide.pdf'],
        ['710-00039.5 Quantum Charger Preventive Maintenance Manual', '2-710-00039.5-Quantum-Charger-Preventive-Maintenance-Manual.pdf'], 
        ['710-00038.1 Lithium Ion CAN Charging Operation', '3-710-00038.1-Lithium-Ion-CAN-Charging-Operation.pdf'],
        ['710-00037.5 Quantum GSE Maintenance Manual', '710-00037.5-Quantum-GSE-Maintenance-Manual.docx'], 
        ['710-00033.1 Battery Charging Instructions for Lithium Ion with BMS Communication', '5-710-00033.1-Battery-Charging-Instructions-for-Lithium-Ion-with-BMS-Communication.pdf'],
        ['710-00025.1 Power Modules Installation Inspection', '6-710-00025.1-Power-Modules-Installation-Inspection.pdf'],
        ['710-00024.1 AC Backplane Remote Stop Installation', '7-710-00024.1-AC-Backplane-Remote-Stop-Installation.pdf'],
        ['710-00005.3 Forklift Battery Charging Instructions', '8-710-00005.3-Forklift-Battery-Charging-Instructions.pdf'],
        ['710-00002.11 Quantum Charger Installation Manual', '710-00002.11-Q3-Charger-Installation-Manual.pdf'],
        ['710-00043.1 Battery Charging Instructions for GSE Charger and Lead-Acid Batteries', '10-710-00043.1-Battery-Charging-Instructions-for-GSE-Charger-and-Lead-Acid-Batteries.pdf'],
        ['710-00042.1 Battery Charging Instructions for GSE Charger and Li-Ion Batteries with BMS Communication', '11-710-00042.1-Battery-Charging-Instructions-for-GSE-Charger-and-Li-Ion-Batteries-with-BMS-Communication.pdf'],
        ['710-00040.3 ACT Preventive Maintenance Guide', '1-710-00040.3-ACT-Preventive-Maintenance-Guide.pdf'],
        ['711-00001 Q3 Charger Installation Manual', '711-00001-Q3-Charger-Installation-Manual.pdf'],
        ['711-00002 Q3 Charger Owners Manual', '711-00002-Q3-Charger-Owners-Manual-1.pdf'],
        ['710-00037.6 Quantum GSE Installation Manual SWA', '710-00037.6-Quantum-GSE-Installation-Manual-SWA.pdf']]
    },

    //Battview
    'TroubleShooting-Battview': { 
      files: [
        ['720-00010.4 BATTview Troubleshooting Faults and Alerts', '1-720-00010.4-BATTview-Troubleshooting-Faults-and-Alerts.pdf']]
    },
    'Programming&Replacement-Battview':{
      files: [
        ['720-00009.3 BATTview Replacement Procedure', '1-720-00009.3-Battview-Replacement-Procedure.pdf']]
    },
    'Technical-Specifications-Battview':{
      files: [
        ['720-00014.2 BATTview Serial Number Breakdown', '1-720-00014.2-BATTview-Serial-Number-Breakdown.pdf'],
        ['720-00017.1 ACT BATTview Comparison', '2-720-00017.1-ACT-BATTview-Comparison.pdf']]
    },
     'Manuals-Battview':{
      files: [
        ['ACT BATTview ll Installation Manual (Tri-lingual Booklet)', '1-Battview-Installation-Manual.pdf'],
        ['710-00040.3 ACT Preventive Maintenance Guide', '2-710-00040.3-ACT-Preventive-Maintenance-Guide.pdf'], 
        ['720-00015.2 BATTview Devices Reassignment Instructions for Dealers', '3-720-00015.2-BATTview-Devices-Reassignment-Instructions-for-Dealers.pdf'],
        ['720-00011.1 BATTview Daughter Card Installation Manual', '4-720-00011.1-BATTview-Daughter-Card-Installation-Manual.pdf'], 
        ['720-00004.1 BATTview Mobile Installation and Setup Manual', '5-720-00004.1-BATTview-Mobile-Installation-and-Setup-Manual.pdf'],
        ['720-00003.8 BATTview ll Short Installation Manual', '6-720-00003.8-BATTview-ll-Short-Installation-Manual.pdf'], 
        ['720-00002.7 BATTview II Installation Manual', '7-720-00002.7-BATTview-II-Installation-Manual.pdf'],
        ['720-00002.3 BATTview Installation Manual', '8-720-00002.3-BATTview-Installation-Manual.pdf']
      ]
    },

    //ACTlink
    'ACTlink':{
      files: [
        ['750-00006.1 Actlink Desulfate Mode', '1-750-00006.1-Actlink-Desulfate-Mode.pdf'],
        ['750-00005.1 ACT-Link Access Permissions', '2-750-00005.1-ACT-Link-Access-Permissions.pdf'], 
        ['750-00001.3-Quantum-and-BATTview-Data-Download-and-Upload-Procedure', '6-750-00001.3-Quantum-and-BATTview-Data-Download-and-Upload-Procedure.pdf'],
        ['750-00002.1-Quantum-and-BATTview-Firmware-Update-Procedure', '5-750-00002.1-Quantum-and-BATTview-Firmware-Update-Procedure.pdf'], 
        ['750-00003.2-Actlink-Software-Download-and-Update-Procedure', '4-750-00003.2-Actlink-Software-Download-and-Update-Procedure.pdf'],
        ['710-00032.1 ACTLink Mobile App Guide v4.1', 'ACTLink-Mobile-App-Guide-v4.1.pdf']
      ]
    },

    //ACTview
    'ACTview':{
      files: [
        ['730-00012.1 ACTview User Manual', '1 730-00012.1-ACTview-User-Manual.docx'],
        ['730-00011.1 ACTview BATTview Mobile Studies', '2-730-00011.1-ACTview-BATTview-Mobile-Studies.pdf'],
        ['730-00010.1 ACTview Getting Started', '3-730-00010.1-ACTview-Getting-Started.pdf.docx'],
        ['730-00008.1 Assigning Devices to a Customer Site', '4-730-00008.1-Assigning-Devices-to-a-Customer-Site.pdf'],
        ['730-00007.1 Simple Table for Access Permissions', '5-730-00007.1-Simple-Table-for-Access-Permissions.pdf'],
        ['730-00006.1 ACTview Site Info Section', '6-730-00006.1-ACTview-Site-Info-Section.pdf'],
        ['730-00005.1 ACTview Manage Tags Section', '7-730-00005.1-ACTview-Manage-Tags-Section.pdf'],
        ['730-00004.1 ACTview Chargers Section', '8-730-00004.1-ACTview-Chargers-Section.pdf'],
        ['730-00003.2 ACTview Batteries Section', '9-730-00003.2-ACTview-Batteries-Section.pdf'],
        ['730-00002.1 ACTview Alerts and Settings', '10-730-00002.1-ACTview-Alerts-and-Settings.pdf'],
        ['730-00001.1 Act-View Registration and Password Retrieval', '11-730-00001.1-Act-View-Registration-and-Password-Retrieval.pdf']
      ]
    },

    //PolarLink
    'Polarlink':{
      files: [
        ['760-00001 Polarlink Installation Manual', '760-00001-Polarlink-Installation-Manual.pdf'],
        ['760-00002 Polarlink Owners Manual', '760-00002-Polarlink-Owners-Manual.pdf']
      ]
    },

    'Service-Bulletins':{
      files: [
        ['Service Bulletin Template', 'ACT-Service-Bulletin-Template.docx'],
        ['Service Bulletin #3 FIN & EQ Window Bug', 'Service-Bulletin-3-FIN-EQ-Window-Bug.pdf'],
        ['Service Bulletin #6 Wall Mounting of Quantum Charger', 'Service-Bulletin-6-Wall-Mounting-of-Quantum-Charger.pdf'],
        ['Service Bulletin #7-6X DC Output Fuse Failure', 'Service-Bulletin-7-6X-DC-Output-Fuse-Failure.pdf'],
        ['Service Bulletin #9 Fixing Time Clock', 'Service-Bulletin-9-Fixing-Time-Clock-.pdf'],
        ['Service Bulletin #10 Fixing Screen Flicker issue', 'Service-Bulletin-10-Fixing-Screen-Flicker-issue.pdf'],
        ['Service Bulletin #11 NEW AC Backplanes', 'Service-Bulletin-11-NEW-AC-Backplanes.pdf'],
        ['Service Bulletin #12 Update FW for 24-36V PMs', 'Service-Bulletin-12-Update-FW-for-24-36V-PMs.pdf'],
        ['Service Bulletin #13 Torque Specs for Quantum Charger DC Fuse', 'Service-Bulletin-13-Torque-Specs-for-Quantum-Charger-DC-Fuse.pdf'],
        ['Service Bulletin #14 MCB RTC Failure', 'Service-Bulletin-14-MCB-RTC-Failure.pdf'],
        ['Service Bulletin #15 MCB Recommended Firmware Update', 'Service-Bulletin-15-MCB-Recommended-Firmware-Update.pdf'],
        ['Service Bulletin #16 Capacitor Failure', 'Service-Bulletin-16-Capacitor-Failure.pdf'],
        ['Service Bulletin #17 Enhanced RMA Claims Process Compliance-Action Required', 'Service-Bulletin-17-Enhanced-RMA-Claims-Process-Compliance-Action-Required.pdf'],
        ['Service Bulletin #18 Important Software Update for Charging Electrovaya Batteries', 'Service-Bulletin-18-Important-Software-Update-for-Charging-Electrovaya-Batteries.pdf'],
        ['Service Bulletin #19 Warranty Shipping Requirements', 'Service-Bulletin-19-Warranty-Shipping-Requirements.pdf']
      ]
    }
}

  headerClassName: string = 'dealerPortalStyle';

  downloadDocument(fileName: string) {
    if(!fileName) return;
    this.homeService?.downloadDealerPortalDoc(fileName).subscribe((res: any) => {
      if(res.url){
        const a = document.createElement('a');
        a.href = res.url;
        a.target = '_blank';  
        a.download = 'Dealer.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    });
  }

}
